// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__rMgFs","loader":"Loader_loader__Nxtnn","rotation":"Loader_rotation__QwgAn"};